import { defineMessages } from "react-intl";

const messages = defineMessages({
  confirmBtn: {
    id: "QZVD+5",
    defaultMessage: "Unassign and save",
    description: "button, unassign attribute from object",
  },
  content: {
    id: "8uLHBY",
    defaultMessage: "Are you sure you want to unassign {attributeName} from {itemTypeName}?",
    description: "unassign attribute from object",
  },
});

export default messages;
